import type { TFunction } from 'i18next'
import { z } from 'zod'

/** A resource set's name is its primary identity, so a rename must resolve to non-empty text. */
export const getRenameResourceSetSchema = (t: TFunction) =>
  z.object({
    name: z.string().trim().min(1, t('prequalifications.resource_set.rename.name_required_error')),
  })

export type RenameResourceSetFormValues = z.infer<ReturnType<typeof getRenameResourceSetSchema>>

/**
 * Deleting a resource set is destructive and irreversible, so the user must retype the
 * resource set's exact name to confirm. The comparison is trimmed on both sides so
 * incidental whitespace does not block an otherwise-correct confirmation.
 */
export const getDeleteResourceSetSchema = (t: TFunction, expectedName: string) =>
  z.object({
    confirmation: z
      .string()
      .trim()
      .refine((value) => value === expectedName.trim(), t('prequalifications.resource_set.delete.name_mismatch_error')),
  })

export type DeleteResourceSetFormValues = z.infer<ReturnType<typeof getDeleteResourceSetSchema>>
